import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Clock } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { useT } from "../i18n";
import api from "../lib/api";

const Blog = () => {
  const { t } = useT();
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Blog — Investir au Maroc | YADIMMO";
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <div className="relative z-10 pt-[72px] min-h-screen bg-background">
      <div className="bg-navy text-white py-16">
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <h1 className="font-display text-4xl sm:text-5xl font-light tracking-tight">{t("blog.title")}</h1>
          <p className="text-white/60 mt-4 max-w-2xl">{t("blog.subtitle")}</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.05}>
              <button data-testid={`blog-card-${p.slug}`} onClick={() => navigate(`/blog/${p.slug}`)} className="group text-start bg-white border border-navy/10 hover:border-gold/60 rounded-2xl overflow-hidden transition-colors flex flex-col h-full">
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={p.cover} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="text-xs text-gold font-semibold uppercase tracking-wider mb-2">{p.category}</div>
                  <h3 className="font-display text-xl text-navy leading-snug mb-2 line-clamp-2">{p.title}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-2 flex-1">{p.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
                    <span className="flex items-center gap-1"><Clock size={14} /> {p.read_time} {t("blog.min")}</span>
                    <span className="text-navy font-semibold group-hover:text-gold inline-flex items-center gap-1">{t("blog.read")} <ArrowRight size={14} className="rtl:rotate-180" /></span>
                  </div>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
